/**
 * EntityMentionPlugin — registers the `entity_mention` inline atom node with
 * the DocsApp ProseMirror schema via schemaExtensionRegistry.
 *
 * This must be imported as a side effect BEFORE `schemaExtensionRegistry.buildExtendedSchema`
 * is called, i.e. before any DocsApp editor is constructed. See the identical
 * pattern used by LibraryApp in `initializeLibraryPlugin.ts`.
 */
import { schemaExtensionRegistry } from './schemaExtensionRegistry';
import {
  ENTITY_MENTION_NODE_NAME,
  entityMentionSpec,
} from '../../../components/RichText/entityMentionNode';
import { createFileLogger } from '../../../utils/logger';

const log = createFileLogger('INLINE_ENTITY');

export function initializeEntityMentionPlugin(): void {
  if (schemaExtensionRegistry.getRegisteredNodes().includes(ENTITY_MENTION_NODE_NAME)) {
    log.log('[INLINE_ENTITY] entity_mention already registered; skipping');
    return;
  }
  schemaExtensionRegistry.registerNode(ENTITY_MENTION_NODE_NAME, entityMentionSpec);
  log.log('[INLINE_ENTITY] entity_mention node registered with Docs schema');
}

// Auto-initialize on import
if (!(globalThis as any).__ENTITY_MENTION_PLUGIN_INITIALIZED__) {
  initializeEntityMentionPlugin();
  (globalThis as any).__ENTITY_MENTION_PLUGIN_INITIALIZED__ = true;
}
